import axios from 'axios';
import { message } from 'antd';
import {
  CATALOG_API
} from '../../../constants/API';
import {
  GET_CATALOGS_LOADING,
  GET_CATALOGS
} from '../types';

function getCatalogs() {
  return async (dispatch, getState) => {
    dispatch({
      type: GET_CATALOGS_LOADING,
      loadingCatalogs: true
    });
    try {
      const accessToken = await localStorage.getItem('accessToken');
      const catalogsResponse = await axios.get(
        `${CATALOG_API}`,
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      dispatch({
        type: GET_CATALOGS,
        loadingCatalogs: false,
        catalogs: catalogsResponse.data
      });
    } catch (e) {
      console.log(e);
      message.error(String(e));
      dispatch({
        type: GET_CATALOGS_LOADING,
        loadingCatalogs: false
      });
    }
  };
}
export default getCatalogs;
